export default [
  {"id":"01","name":"中共党员"},{"id":"02","name":"中共预备党员"},{"id":"03","name":"共青团员"},
  {"id":"04","name":"民革党员"},{"id":"05","name":"民盟盟员"},{"id":"06","name":"民建会员"},
  {"id":"07","name":"民进会员"},{"id":"08","name":"农工党党员"},{"id":"09","name":"致公党党员"},
  {"id":"10","name":"九三学社社员"},{"id":"11","name":"台盟盟员"},{"id":"12","name":"无党派人士"},
  {"id":"13","name":"普通居民(群众)"}
];